// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13yZj","fullView":"styles_fullView__3En4X"};